/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export * from './dialog';
export * from './dialog-config';
export * from './dialog-ref';
export * from './dialog-content-directives';
export {_MatDialogContainerBase, MatDialogContainer} from './dialog-container';
export * from './module';
export {matDialogAnimations, _defaultParams} from './dialog-animations';
